import { Component, OnInit, Input, ElementRef } from '@angular/core';

import { LayoutSidebarService } from '../services/sidebar.service';

@Component({
  selector: 'uex-layout-sidebar',
  templateUrl: './sidebar.component.html',
  host: {
    class: 'uex-layout-sidebar',
    '[class.uex-layout-sidebar-left]': 'side == "left"',
    '[class.uex-layout-sidebar-right]': 'side == "right"'
  }
})
export class LayoutSidebarComponent implements OnInit {
  @Input('side') public side: 'left' | 'right' = 'left';

  constructor(
    private _sidebarService: LayoutSidebarService,
    public elementRef: ElementRef
  ) { }

  private _visible = false;

  public get visible(): boolean {
    return this._visible;
  }

  public ngOnInit() {
    this._sidebarService.$registerSidebar(this.side, this);
  }

  public ngOnDestroy() {
    this._sidebarService.$unregisterSidebar(this.side);
  }

  public setVisible(visible: boolean) {
    this._visible = visible ? true : false;
    this._sidebarService.onVisibilityChange.emit(this);
  }

  public toggleVisible() {
    this.setVisible(!this._visible);
  }
}
